import { track, logError } from '@tracking';
import getShopId from '@core/reducers/shop/selectors/getShopId';

const EVENT_NAME = 'review.loaded';

const trackShopReviewsLoaded = () => (_, getState) => {
  try {
    const shopId = getShopId(getState());
    const payload = { shopId };

    track(EVENT_NAME, payload);
  } catch (error) {
    logError(EVENT_NAME, error);
  }
};

export default trackShopReviewsLoaded;
